'use client';

import { WaitlistCTA } from '@/components/marketing/WaitlistCTA';
import { Skeleton } from '@/components/ui/skeleton';
import { theme } from '@/lib/ui/theme';

interface FinalCTASectionProps {
  isLoading?: boolean;
}

export function FinalCTASection({ isLoading = false }: FinalCTASectionProps) {
  if (isLoading) {
    return (
      <section className="px-6 py-12 pb-20 md:px-16 md:py-16 md:pb-24">
        <div className="mx-auto max-w-[1200px] text-center">
          <Skeleton className="mx-auto mb-6 h-10 w-[60%]" />
          <Skeleton className="mx-auto mb-8 h-6 w-[75%]" />
          <Skeleton className="mx-auto h-12 w-48 rounded-lg" />
        </div>
      </section>
    );
  }

  return (
    <section className="px-6 py-12 pb-20 md:px-16 md:py-16 md:pb-24">
      <div className="mx-auto max-w-[1200px] text-center">
        <p
          className="text-foreground/70 mb-4 text-lg md:text-xl"
          style={{ fontFamily: theme.fonts.body }}
        >
          Catch what your agent missed, before it merges.
        </p>
        <h2
          className="text-gradient-hero mb-8 text-3xl font-bold tracking-tight md:text-4xl"
          style={{ fontFamily: theme.fonts.display }}
        >
          Trust the code your agent ships.
        </h2>
        <WaitlistCTA label="Install the GitHub App" source="final_cta" />
      </div>
    </section>
  );
}
